import { useTranslation } from "react-i18next";
import { AiOutlineInfo } from "react-icons/ai";
import ReactTooltip from "react-tooltip";
import {
  EvmcType,
  ReferenceSelection,
} from "../../../models/EvmcSelections";
import "./customDropDownList.css";
import SimpleDropDownList from "./simpleDropDownList";

export type Props<T> = {
  selection: ReferenceSelection<T>;
  setSelectionHandler: (selection: ReferenceSelection<T>) => void;
  values: string[];
  type: EvmcType;
};

const ReferenceFilterComponent = <T,>({
  selection,
  setSelectionHandler,
  values,
  type,
}: Props<T>) => {
  const { t } = useTranslation();

  const changeRef = (newValue: T) => {
    setSelectionHandler({ ...selection, ref: newValue });
  };

  const changeSecondary = (newValue: T) => {
    setSelectionHandler({ ...selection, secondary: newValue });
  };

  const getLabel = () => {
    switch (type) {
      case EvmcType.CATEGORY:
        return t("evmc-filter-title-category");
      case EvmcType.EDUCATION:
        return t("evmc-filter-title-education");
      default:
        return t("evmc-filter-title-living");
    }
  };

  // Mantis 17561 : On exclut de la liste de gauche la valeur "Ensemble" ("all")
  const refValues = values.filter(v => v !== 'all').filter(v => v !== selection.secondary as unknown as string)
  const secondaryValues = values.filter(v => v !== selection.ref as unknown as string)

  const displayInfoTooltip = (): boolean => {
    return type !== EvmcType.CATEGORY;
  }

  return (
    <div className="filter-type-container">
      <div className="info-row">
        <label style={{marginRight: "8px"}} id="label-reference-filter">
          { getLabel() }
        </label>
        { displayInfoTooltip() ? (
          <>
            <span
              aria-label="détails sur ce filtre"
              aria-controls="infoFilterTip"
              data-tip
              data-for="infoFilterTip"
              className="info-round-button"
            >
              <AiOutlineInfo
                style={{ color: "#0C3A5A" }}
              ></AiOutlineInfo>
            </span>
            <ReactTooltip
              id="infoFilterTip"
              place="bottom"
              effect="solid"
              multiline={true}
              html={true}
            >
              {t(`evmc-${type}-info`)}
            </ReactTooltip>
          </>
        ) : undefined}
      </div>

      <div className="two-selectors">
        <SimpleDropDownList
          handleSelection={(newValue) =>
            changeRef(newValue as T)
          }
          values={refValues}
          selectedValue={selection.ref as string}
          type={type}
          id="comparateur-borne-inf"
          ariaLabel="Borne inférieure du comparateur"
          ariaDetails={ displayInfoTooltip() ? "label-reference-filter infoFilterTip" : "label-reference-filter" }
        />

        <label style={{ margin: "0 8px" }}>
          {t("evmc-filter-to")}
        </label>

        <SimpleDropDownList
          handleSelection={(newValue) =>
            changeSecondary(newValue as T)
          }
          values={secondaryValues}
          selectedValue={selection.secondary as string}
          type={type}
          id="comparateur-borne-sup"
          ariaLabel="Borne supérieure du comparateur"
          ariaDetails={ displayInfoTooltip() ? "label-reference-filter infoFilterTip" : "label-reference-filter" }
        />
      </div>
    </div>
  );
};

export default ReferenceFilterComponent;
